export const ARCS_PRIMARY_COLOR = "#6bcdf4"; // blue (URL / Arcs tenant)
export const ARCS_SECONDARY_COLOR = "#F6CD3B"; //yellow
export const ARCS_TERTIARY_COLOR = "#fff"; //white
export const ARCS_PULSE_COLOR = "#77c970" //vibrant green
export const ARCS_PRIMARY_LIGHT_COLOR = "#8F71C5" //light purple
export const ARCS_HIGHLIGHT_COLOR = "#8F71C5" //light purple